import { TranslationsProvider } from "@/TranslationsProvider";
import "@/styles/globals.css";
import { theme } from "@/styles/theme";
import { ChakraProvider } from "@chakra-ui/react";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import weekday from "dayjs/plugin/weekday";
import { SessionProvider } from "next-auth/react";
import type { AppProps } from "next/app";
import { trpc } from "../utils/trpc";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

function App({ Component, pageProps }: AppProps) {
  return (
    <ChakraProvider theme={theme}>
      <SessionProvider session={pageProps.session}>
        <TranslationsProvider>
          <Component {...pageProps} suppressHydrationWarning />
        </TranslationsProvider>
      </SessionProvider>
    </ChakraProvider>
  );
}

export default trpc.withTRPC(App);
